CustomTC.define('main',['modules/core', 'main-common', "clipboard/clipboard", "hls/hls.min"], function(core, mainCommon, Clipboard,Hls) {
    window.Clipboard = Clipboard;
    window.Hls = Hls;
    mainCommon['parseJSON'] = core.parseJSON;
    return mainCommon;
});
